const endpoints ={
    getFineByUID: '/api/complaints/getFineByUID',

}

export {endpoints}